import { v4 } from 'uuid';
import { PermissionRole } from '@fabric/woody-client';

const createOptimisticSpace = (user, title, role) => {
  const optimisticId = v4();
  return {
    isDraft: true,
    id: optimisticId,
    title,
    role,
    owner: {
      ...user,
      name: user.name || "Unknown",
      picture: user.pictureUrlCdn || null
    },
    type: "SPACE",
    isPublic: false,
    integration: null,
    labels: [],
    createdAt: (/* @__PURE__ */ new Date()).toISOString(),
    modifiedAt: (/* @__PURE__ */ new Date()).toISOString()
  };
};
const createOptimisticSpaceRoot = (name = "New space") => {
  const id = v4();
  return {
    isDraft: true,
    id,
    type: "SPACE",
    folder: {
      id,
      icon: null,
      name,
      isReadonly: false,
      permissions: {
        role: PermissionRole.OWNER
      },
      childrenCount: 0,
      memberCount: 1,
      isPublic: false
    },
    subtype: null,
    createdAt: (/* @__PURE__ */ new Date()).toISOString(),
    modifiedAt: (/* @__PURE__ */ new Date()).toISOString(),
    subFoldersCount: 0
  };
};

export { createOptimisticSpace, createOptimisticSpaceRoot };
//# sourceMappingURL=createOptimisticSpace.js.map
